import { FC, useEffect, useMemo, useRef, useState } from "react";
// 组件
import SuperSelect from "../SuperSelect";
import TextAreaRow from "../TextAreaRow";
import RadioGroup from "../RadioGroup";
// 方法
import classNames from "classnames";
import { filterEmptyFieldGroupSearchValue } from "./util";
// 常量
import { RadioChangeEvent } from "antd/lib/radio";
import { DEFAULT_FIELD_NAMES, FieldGroupSearchProps } from "./interface";
import './style.less';

/** 组合搜索 */
const FieldGroupSearch: FC<FieldGroupSearchProps> = props => {
  const {
    value: outValue, className, style, disabled, fieldNames, upperCaseSearchType, defaultValue,
    typeSuperSelectProps, fieldSuperSelectProps, valueAreaRowProps, matchRuleRadioGroupProps, onChange,
  } = props;
  const [ value, setValue ] = useState<any>(filterEmptyFieldGroupSearchValue(defaultValue, fieldNames));
  const [placeholder, setPlaceholder] = useState<string>(); // 多行文本框提示文字
  const isFirst = useRef<boolean>(true); // 是否需要根据外部传入value设置值
  /** 根据外部传入value设置值 */
  useEffect(() => {
    if (isFirst.current && !outValue) return;
    const newValue = filterEmptyFieldGroupSearchValue(outValue, fieldNames);
    setValue(newValue);
    isFirst.current = false;
  }, [outValue, fieldNames]);
  /** 类型改变 */
  const handleTypeChange = (val: any) => {
    const newValue: any = {
      [fieldNames?.type || DEFAULT_FIELD_NAMES.type]: val,
    }
    handleChange(newValue);
  };
  /** 字段改变 */
  const handleFieldChange = (val: any, options: any) => {
    const newValue: any = {
      [fieldNames?.field || DEFAULT_FIELD_NAMES.field]: val,
    }
    setPlaceholder(options?.label as string);
    handleChange(newValue);
  };
  /** 值改变 */
  const handleValueChange = (val: any) => {
    handleChange({ [fieldNames?.value || DEFAULT_FIELD_NAMES.value]: val, });
  };
  /** 匹配规则改变 */
  const handleMatchRuleChange = (event: RadioChangeEvent) => {
    handleChange({ [fieldNames?.rule || DEFAULT_FIELD_NAMES.rule]: event.target.value, });
  };
  /** value值改变 */
  const handleChange = (otherValue: any) => {
    setValue((prev: any) => {
      const newValue = filterEmptyFieldGroupSearchValue({ ...prev, ...otherValue, }, fieldNames);
      onChange?.(newValue);
      return newValue;
    });
  };
  /** 组件类名 */
  const classes = useMemo(() => {
    return classNames('field-group-search', className, {
      'field-group-search-disabled': disabled,
    });
  }, [className]);

  return (
    <div className={classes} style={style}>
      <SuperSelect
        showSearch={false}
        allowClear
        {...typeSuperSelectProps}
        className="field-group-search-type"
        value={value?.[fieldNames?.type || DEFAULT_FIELD_NAMES.type]}
        onChange={handleTypeChange}
      />
      <SuperSelect
        showSearch={false}
        allowClear
        {...fieldSuperSelectProps}
        className="field-group-search-field"
        value={value?.[fieldNames?.field || DEFAULT_FIELD_NAMES.field]}
        onChange={handleFieldChange}
      />
      <TextAreaRow
        placeholder={placeholder}
        allowClear
        {...valueAreaRowProps}
        className="field-group-search-value"
        value={value?.[fieldNames?.value || DEFAULT_FIELD_NAMES.value]}
        isUpperCase={upperCaseSearchType?.includes(value?.[fieldNames?.field || DEFAULT_FIELD_NAMES.field])}
        onChange={handleValueChange}
        dropdownHeader={
          <div className='flex-center-start' style={{ marginBottom: 4, }}>
            {
              !!matchRuleRadioGroupProps?.title && (
                <div className='p-r-s'>{matchRuleRadioGroupProps.title}:</div>
              )
            }
            <RadioGroup
              size="small"
              optionType="button"
              {...matchRuleRadioGroupProps}
              value={value?.[fieldNames?.rule || DEFAULT_FIELD_NAMES.rule]}
              onChange={handleMatchRuleChange}
            />
          </div>
        }
      />
    </div>
  );
};

export default FieldGroupSearch;
